<template>
  <div class="Notification-fallback">
    <div class="Notification-fallbackGraphic">
      <svg>
        <use xlink:href="#bell" />
      </svg>
    </div>
    <h3>You have no notifications</h3>
    <p>Your recently saved jobs, reviews and companies will appear here.</p>
    <!--<p><a href="/dashboard/saved-items/saved-jobs">Learn more</a></p>-->
  </div>
</template>
